import React, { useState } from "react";
import { Link } from "react-router-dom";
import useSettingsFetch from "../hooks/useSettingsFetch";
import ModalLiberacion from "../components/ModalLiberacion";
import ExcelDownloader from "../components/ExcelDownloader";

const TablaSetting = () => {
  const { settings, loading, error, refetch } = useSettingsFetch();
  const [modalCargaId, setModalCargaId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(settings.length / itemsPerPage);
  const paginatedSettings = settings.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <h1>
          Cargando
          <p>
            <svg id="page-preload" viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </p>
        </h1>
      </div>
    );
  if (error) return <div>{error}</div>;

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Configuraciones disponibles</h3>
        </div>
        <div className="table-responsive">
          <table className="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Código - Convenio</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSettings.map((row) => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>{row.Nombre}</td>
                  <td>{row.Settings ? `${row.Settings.accountCode || "N/A"} - ${row.Settings.displayName || "Sin nombre"}` : "No disponible"}</td>
                  <td>
                    <span className="badge bg-success me-1"></span>Activo
                  </td>
                  <td>
                    {row.boton === "cargar" && (
                      <Link to={`/panel/CargaVales/${row.id}`} className="btn btn-sm btn-primary me-2">
                        Cargar
                      </Link>
                    )}
                    {row.boton === "crear_servicios" && (
                      <>
                        <Link to={`/panel/CrearServicios/${row.id}`} className="btn btn-sm btn-success me-2">
                          Crear Servicios
                        </Link>
                        <button className="btn btn-sm btn-secondary me-2" onClick={() => setModalCargaId(row.id)}>
                          Liberar
                        </button>
                      </>
                    )}
                    <ExcelDownloader row={row} fileName={`Formato-${row.id}`} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Paginación */}
        <div className="card-footer d-flex justify-content-center align-items-center gap-2">
          <button className="btn btn-outline-primary btn-sm" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>
            Anterior
          </button>
          <span>
            Página {currentPage} de {totalPages}
          </span>
          <button className="btn btn-outline-primary btn-sm" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>
            Siguiente
          </button>
        </div>
      </div>

      {/* Modal */}
      {modalCargaId && (
        <ModalLiberacion
          cargaId={modalCargaId}
          onClose={() => {
            setModalCargaId(null);
            refetch(); // 👈 refresca la tabla
          }}
        />
      )}
    </>
  );
};

export default TablaSetting;
